import { environment } from '../../environments/environment';

// Matches both `/assigned-form/{id}` page navigations and the API path.
const ASSIGNED_FORM_PATH = /\/assigned-form\/([^/?#]+)/;

// 401 shortly after a login attempt = cookie not persisting; stop the loop.
const LOGIN_ATTEMPT_WINDOW_MS = 20_000;

const attemptKey = (assignedFormId: string): string => `fr-login-attempt:${assignedFormId}`;

export function currentAssignedFormId(): string | null {
  return ASSIGNED_FORM_PATH.exec(window.location.pathname)?.[1] ?? null;
}

export function loginUrl(assignedFormId: string): string {
  return `${environment.apiBaseUrl}/api/auth/form-renderer/${assignedFormId}/login`;
}

export function markLoginAttempt(assignedFormId: string): void {
  try {
    sessionStorage.setItem(attemptKey(assignedFormId), Date.now().toString());
  } catch {
    // sessionStorage unavailable — proceed without the guard
  }
}

export function hasRecentLoginAttempt(assignedFormId: string): boolean {
  try {
    const raw = sessionStorage.getItem(attemptKey(assignedFormId));
    if (!raw) return false;
    return Date.now() - Number(raw) < LOGIN_ATTEMPT_WINDOW_MS;
  } catch {
    return false;
  }
}

export function clearLoginAttempt(assignedFormId: string): void {
  try {
    sessionStorage.removeItem(attemptKey(assignedFormId));
  } catch { /* sessionStorage unavailable */ }
}
